$(document).ready(function() { 
   $(".cleaner-hero-banner").slick({
    dots: false,
    arrows:false,    
    infinite: true,
    speed: 300,
    slidesToShow: 1,
  });
  
  
function product_slide() {

  var announcementBREAKPOINT = 767;
  var announcementSlideIndex = 0;
  var announcementSlider = ".products-list";
  var windowWidth = $(window).width();

  var announcementSliderConfig = {
    dots: true,
    arrows:false,    
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          infinite: true,
          slidesToShow: 1
        }
      }
    ]
  };

  if (windowWidth <= announcementBREAKPOINT) {
	$(announcementSlider).on("afterChange", function (event, slick, currentSlide1) {
          announcementSlideIndex = currentSlide1;
    }).slick(announcementSliderConfig);
  }

  var resizeTimeout;
  $(window).resize(function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
        var windowWidth = $(window).width();
        if (windowWidth >= announcementBREAKPOINT) {
            //desktop
            if ($(announcementSlider+'.slick-initialized').length > 0) {
                $(announcementSlider).slick("unslick");
            }	
        } else {
            // mobile
            if ($(announcementSlider+'.slick-initialized').length == 0) {
                $(announcementSlider).slick(announcementSliderConfig);
            } else {
                $(announcementSlider).slick("unslick").slick(announcementSliderConfig);
                $(announcementSlider).slick('slickGoTo', announcementSlideIndex, true);
            }				
        }
    }, 300);
  });
  
  /*$(".products-list").slick({
    dots: true,
    arrows:false,    
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
      responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 1.5,
        },
      }
    ]
  });*/
}
product_slide();

function client_slide() {
  $(".client-list").slick({
    dots: true,
    arrows:false,    
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    centerMode: true,
      responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      }
    ]
  });
}  

function header_contact_info() {
  $(".featured-content--container > ul").slick({
    dots: false,
    arrows:false,    
    infinite: true,
    speed: 300,
    slidesToShow: 2,
      responsive: [
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ]
  });
} 
  client_slide();
$(window).resize(function() {
  if ($(window).width() <= 767) {  
      //product_slide();
      //client_slide();
  }

  if ($(window).width() <= 991) {  
      header_contact_info();
  }
});  
  
if ($(window).width() <= 767) {  
    //product_slide();
    //client_slide();
}

if ($(window).width() <= 991) {  
    header_contact_info();
}
  
});  
